import { MAILTO } from "@/lib/mailto";

const BG_URL =
  "https://customer-assets.emergentagent.com/job_ryder-consulting/artifacts/8gmr4b5p_ChatGPT%20Image%20Jun%2011%2C%202026%2C%2009_32_41%20PM.png";

export default function Contact() {
  return (
    <section
      id="contact"
      data-testid="section-contact"
      className="bg-paper relative"
      style={{
        backgroundImage: `url('${BG_URL}')`,
        backgroundPosition: "right center",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
      }}
    >
      {/* Lightening overlay: stronger on mobile, softer on desktop */}
      <div
        aria-hidden="true"
        className="absolute inset-0 pointer-events-none bg-[rgba(250,250,247,0.62)] md:bg-[rgba(250,250,247,0.34)]"
        data-testid="contact-bg-overlay"
      />
      <div className="relative mx-auto max-w-[1100px] px-6 py-28 md:px-10 md:py-32 lg:py-40">
        <h2 className="contact-heading max-w-[760px]" data-testid="contact-heading">
          {"Let\u2019s talk."}
        </h2>

        <p
          className="mt-6 max-w-[560px]"
          data-testid="contact-sub"
          style={{
            fontFamily: "Inter, Arial, sans-serif",
            fontSize: "18px",
            lineHeight: 1.6,
            color: "rgba(26,58,79,0.85)",
          }}
        >
          {"You\u2019ve been the only one thinking it through for long enough. Tell me what\u2019s on your plate."}
        </p>

        <div className="mt-10 flex flex-col items-start gap-4">
          <a
            href={MAILTO}
            data-testid="contact-cta-start-conversation"
            className="btn-primary"
          >
            Start a conversation
          </a>
          <div
            data-testid="contact-microcopy"
            style={{
              fontFamily: "Inter, Arial, sans-serif",
              fontSize: "14px",
              color: "var(--color-soft-gray)",
              lineHeight: 1.4,
            }}
          >
            <p>I take on a small number of projects at a time.</p>
            <p className="mt-2">No pitch deck required.</p>
          </div>
        </div>
      </div>
    </section>
  );
}
